import client from './main-client';

export const consultantsApi = (params) => client().get('/consultants', { params });
